import React, { useState } from "react";
import DataTable from 'react-data-table-component';

function Earnings() {
    const [searchText, setSearchText] = useState('');

    // Data definition for DataTable
    const earningsData = {
        columns: [
            { name: "MINING DATE", selector: row => row.date, sortable: true },
            { name: "DAILY HASHRATE", selector: row => row.hashrate, sortable: true },
            { name: "TYPE", selector: row => row.type, sortable: true },
            { name: "NETWORK DIFFICULTY", selector: row => row.difficulty, sortable: true },
            { name: "EARNINGS (BTC)", selector: row => row.earnings, sortable: true },
            {
                name: "STATUS",
                selector: row => row.status,
                sortable: true,
                cell: row => {
                    const badgeClass = row.status === 'Completed' ? 'bg-success' :
                        row.status === 'Pending' ? 'bg-warning' : 'bg-danger';
                    return <span className={`badge ${badgeClass} `}>{row.status}</span>;
                }
            },
        ],
        rows: [
            { id: 1, date: '2025-03-10', hashrate: '109.8 TH/s', type: 'BTC', difficulty: '83.45 T', earnings: '0.00041', status: 'Completed' },
            { id: 2, date: '2025-03-09', hashrate: '111.2 TH/s', type: 'BTC', difficulty: '83.45 T', earnings: '0.00043', status: 'Completed' },
            { id: 3, date: '2025-03-08', hashrate: '107.6 TH/s', type: 'BTC', difficulty: '82.90 T', earnings: '0.00039', status: 'Completed' },
            { id: 4, date: '2025-03-07', hashrate: '110.4 TH/s', type: 'BTC', difficulty: '82.90 T', earnings: '0.00042', status: 'Completed' },
            { id: 5, date: '2025-03-06', hashrate: '108.1 TH/s', type: 'BTC', difficulty: '82.10 T', earnings: '0.00040', status: 'Completed' },
            { id: 6, date: '2025-03-05', hashrate: '112.7 TH/s', type: 'BTC', difficulty: '82.10 T', earnings: '0.00044', status: 'Pending' },
            { id: 7, date: '2025-03-04', hashrate: '106.9 TH/s', type: 'BTC', difficulty: '81.75 T', earnings: '0.00038', status: 'Completed' },
            { id: 8, date: '2025-03-03', hashrate: '109.3 TH/s', type: 'BTC', difficulty: '81.75 T', earnings: '0.00041', status: 'Completed' },
            { id: 9, date: '2025-03-02', hashrate: '113.5 TH/s', type: 'BTC', difficulty: '81.20 T', earnings: '0.00045', status: 'Completed' },
            { id: 10, date: '2025-03-01', hashrate: '108.7 TH/s', type: 'BTC', difficulty: '81.20 T', earnings: '0.00040', status: 'Failed' },
        ]
    };

    // Filter function for search
    const filterData = (data) => {
        if (!searchText) return data;

        return data.filter(item => {
            return Object.values(item).some(val =>
                String(val).toLowerCase().includes(searchText.toLowerCase())
            );
        });
    };

    return (
        <>
            <div className="body-header border-bottom d-flex py-3">
                <div className="container-xxl">
                    <div className="row align-items-center g-2">
                        <div className="col">
                            {/* Pretitle */}
                            <h1 className="h4 mt-1">Earnings</h1>
                        </div>
                        <div className="col-12 col-md-6 text-md-end">
                            <span className="fs-6 me-2">Accumulated</span>
                            <button type="button" className="btn btn-dark lift">0.00039 BTC</button>
                        </div>
                    </div> {/* Row end  */}
                </div>
            </div>

            {/* Body: Body */}
            <div className="body d-flex py-3">
                <div className="container-xxl">

                    <div className="row g-3">
                        <div className="card mb-3">
                            <div className="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                                <h6 className="m-0 fw-bold">Earnings History for John Quinn</h6>
                            </div>
                            <div className="card-body">
                                {/* Search Box */}
                                <div className="row mb-3">
                                    <div className="col-sm-12 col-md-12">
                                        <div id="myDataTable_filter" className="dataTables_filter">
                                            <label className='d-flex align-items-center justify-content-end'>
                                                Search:
                                                <div className='mx-1'>
                                                    <input
                                                        type="search"
                                                        className="form-control"
                                                        value={searchText}
                                                        onChange={(e) => setSearchText(e.target.value)}
                                                        placeholder="Search..."
                                                    />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <DataTable
                                    columns={earningsData.columns}
                                    data={filterData(earningsData.rows)}
                                    defaultSortField="date"
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    selectableRows={false}
                                    className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                    highlightOnHover={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Earnings;
